<template>
  <div class="loki-cards-graph">
    <b-row style="margin-bottom: 2rem">
      <b-col
        cols="6"
        md="4"
        :class="index >= 3 ? 'mt-4' : ''"
        v-for="(card, index) in cards"
        :key="index"
      >
        <app-card :data="card" />
      </b-col>
    </b-row>
    <!-- <b-container fluid class="bg-white my-3">
      <b-row>
        <b-col cols="12">
          <b-row class="pt-4">
            <b-col cols="7">
              <h5 class="f-default">Findings</h5>
              <small class="f-default" v-if="range"
                >{{ range.start | dateLL }} à {{ range.end | dateLL }}</small
              >
              <small v-else>--</small>
            </b-col>
            <b-col cols="5">
              <v-date-picker
                v-model="range"
                is-range
                :masks="masks"
                locale="pt"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="flex justify-center items-center">
                    <b-form-input
                      :value="`${
                        inputValue.start !== null
                          ? `${inputValue.start} - ${inputValue.end}`
                          : '-----'
                      } `"
                      v-on="inputEvents.start"
                    />
                    <button @click="range = ''" class="btn-x">
                      <i class="bi bi-x-circle"></i>
                    </button>
                  </div>
                </template>
              </v-date-picker>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" v-if="graph.length > 0">
          <graph-donnuts :data="graph" label="Findings" />
        </b-col>
        <b-col cols="12" v-else class="pt-5">
          <b-alert show variant="warning" class="w-100">
            <p class="f-default mb-0 text-center">Nenhum dado encontrado</p>
          </b-alert>
        </b-col>
      </b-row>
    </b-container> -->
  </div>
</template>
<script>
import appCard from './_cards'
// import graphDonnuts from '@/components/graphs/_donnuts'
import moment from 'moment'
export default {
  props: {
    cards: Array,
    graph: Array,
  },
  components: {
    appCard,
    // graphDonnuts,
  },
  watch: {
    range() {
      if (this.range === '') {
        this.$emit('clean')
      }
      const start = moment(this.range.start)
      const end = moment(this.range.end)
      this.$emit('date', {
        start: start.format('DD/MM/YYYY'),
        end: end.format('DD/MM/YYYY'),
      })
    },
  },

  data() {
    return {
      range: '',
      search: '',
      masks: {
        input: 'DD/MM/YYYY',
      },
    }
  },
}
</script>
<style lang="scss">
#pieChart {
}
</style>
